import type { MultiSearchResult } from './searchLegacy.types';
import { collectionMapWithoutActions } from '../search/search';
import { typesense } from '../typesenseClient';
import { TypesenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const getCollectionsFromCategories = (
  searchCategories: string[],
  apiKeys: TypesenseAPIKeys,
) => {
  return {
    searches: searchCategories.length
      ? searchCategories
          .map((item) => item.trim())
          .filter(
            (item) =>
              collectionMapWithoutActions[item] &&
              apiKeys[collectionMapWithoutActions[item].keyName],
          ) // only keep valid entries and those with api keys present
          .map((item) => ({
            collection: collectionMapWithoutActions[item].name,
            'x-typesense-api-key':
              apiKeys[collectionMapWithoutActions[item].name].key,
            query_by: collectionMapWithoutActions[item].queryableFields,
            exclude_fields: 'embedding,TenantId',
            ...(collectionMapWithoutActions[item].filter && {
              filter_by: collectionMapWithoutActions[item].filter,
            }),
            ...(collectionMapWithoutActions[item].infix && {
              infix: collectionMapWithoutActions[item].infix,
            }),
          }))
      : [],
  };
};

export const getSearch = (
  searchValue: string,
  searchCategories: string[],
  apiKeys: TypesenseAPIKeys,
): Promise<MultiSearchResult> => {
  const searchRequests = getCollectionsFromCategories(
    searchCategories,
    apiKeys,
  );

  const commonSearchParams = {
    q: searchValue,
    num_typos: 2,
    min_len_1typo: 3,
    per_page: 20,
    enable_typos_for_numerical_tokens: false,
  };

  if (!searchRequests.searches.length) {
    // If no valid searches, return an empty result
    return Promise.resolve({
      results: [],
    } as MultiSearchResult);
  }

  // Cast to align with our MultiSearchResult type
  return typesense.multiSearch.perform(
    searchRequests as unknown as Parameters<
      typeof typesense.multiSearch.perform
    >[0],
    commonSearchParams,
  ) as Promise<MultiSearchResult>;
};
